import ReactDOM from "react-dom/client";

import Routes from "./Routes";

const root = ReactDOM.createRoot(document.getElementById("root")!);
root.render(<Routes />);
